import { Typography } from "@mui/material";
import React from "react";

export default function Wallet({ data }) {
  return (
    <Typography color="text.secondary" variant="subtitle1">
      {data?.broker}
    </Typography>
  );
}
